import styled from 'styled-components';

import { GridContent, GridLayout, token } from '@zillow/constellation';

export const StyledGridLayout = styled(GridLayout)`
  gap: 16px;
`;

export const StyledGridContent = styled(GridContent)`
  border: 1px solid ${token('colors.gray300')};
  text-align: center;
`;
